import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { CommissionTierItemDto } from '../../commission-tier-items/dtos/commission-tier-item.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';

/**
 * Create agent category DTO
 */
export class CreateAgentCategoryDto {
  color?: string | null;
  name!: string;
  description?: string | null;
  notes?: string | null;
  commissionTierItems?: CommissionTierItemDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
